import { RouteObject } from "react-router-dom";

export const faqRoutes: RouteObject[] = [
  {
    children: [
      {
        index: true,
        lazy: async () => {
          const { Home } = await import("./home");
          return { element: <Home /> };
        },
      },
      {
        path: "collection/:collectionId",
        lazy: async () => {
          const { Home } = await import("./home");
          return { element: <Home /> };
        },
      },
      {
        path: "article/:articleId",
        lazy: async () => {
          const { Home } = await import("./home");
          return { element: <Home /> };
        },
      },
      {
        path: ":pageId",
        lazy: async () => {
          const { Home } = await import("./home");
          return { element: <Home /> };
        },
      },
      {
        path: ":pageId/collection/:collectionId",
        lazy: async () => {
          const { Home } = await import("./home");
          return { element: <Home /> };
        },
      },
      {
        path: ":pageId/article/:articleId",
        lazy: async () => {
          const { Home } = await import("./home");
          return { element: <Home /> };
        },
      },
    ],
  },
];
